import React from 'react';
import {connect} from "react-redux";
import { toast } from 'react-toastify';
import Request from '../../../../../config/Request.js'
import form from "../../../../../superuser/user/form.js"
import {ButtonValidation} from '../../../../../component/Button.js'
import {UpdateUserSessionProperties} from '../../../../../user/action.js'

export class Settings extends React.Component {
  constructor(props) {
    super(props);
    const {UserReducer} = this.props
    
    this.state = {
      username    : UserReducer.username,
      firstname   : UserReducer.props.first_name,
      lastname    : UserReducer.props.last_name,
      reset       : false,
      is_process  : false,
      oldpassword : "",
      newpassword : "",
    }

    this.onUpdateProfile         = this.onUpdateProfile.bind(this)
    this.onUpdateProfileSuccess  = this.onUpdateProfileSuccess.bind(this)
    this.onUpdateProfileFailed   = this.onUpdateProfileFailed.bind(this)
    
    this.onUpdatePassword        = this.onUpdatePassword.bind(this)
    this.onUpdatePasswordSuccess = this.onUpdatePasswordSuccess.bind(this)
    this.onUpdatePasswordFailed  = this.onUpdatePasswordFailed.bind(this)
    
    this.resetPassword           = this.resetPassword.bind(this)
  }

  resetPassword() {
    this.setState({
      reset: !this.state.reset
    })  
  }

  // NOTE : Update Profile
  onUpdateProfile() {
    if(!form.ValidateFormProfile(this.state)) return 
    
    this.setState({
      is_process: true
    })

    let data = {
      payloads: {
        FirstName : this.state.firstname,
        LastName  : this.state.lastname,
      }
    }

    Request(
      "put",
      "superuser-update-profile",
      {Authorization: "Bearer " + this.props.UserReducer.token},
      data.payloads,
      [],
      this.onUpdateProfileSuccess,
      this.onUpdateProfileFailed
    )
  }

  onUpdateProfileSuccess(response) {
    this.props.RunRedux(UpdateUserSessionProperties(response.data))
    this.setState({ is_process: false })
    toast.success("Update profile success")
  }

  onUpdateProfileFailed(error) {
    let data = error.response.data
    this.setState({ is_process: false })

    try {
      for(let key in data) {
        if(data.hasOwnProperty(key)) {
          toast.error("Error : " + data[key])
        }
      }
    }catch(error) {
      console.log(error);
    }
  }

  // NOTE : Update password
  onUpdatePassword() {
    if(!form.ValidateFormPassword(this.state)) return 
    this.setState({ is_process: true })

    let data = {
      payloads: {
        OldPassword : this.state.oldpassword,
        Password    : this.state.newpassword,
      }
    }

    Request(
      "put",
      "superuser-update-password",
      {Authorization: "Bearer " + this.props.UserReducer.token},
      data.payloads,
      [],
      this.onUpdatePasswordSuccess,
      this.onUpdatePasswordFailed
    )
  }

  onUpdatePasswordSuccess(response) {
    this.setState({ is_process: false })
    this.setState({
      oldpassword: '',
      newpassword: '',
    })
    toast.success("Update password success")
  }

  onUpdatePasswordFailed(error) {
    this.setState({ is_process: false })
    let data = error.response.data

    try {
      for(let key in data) {
        if(data.hasOwnProperty(key)) {
          toast.error("Error : " + data[key])
        }
      }
    }catch(error) {
      console.log(error);
    }
  }

  renderProfile() {
    const {username, firstname, lastname, is_process} = this.state

    return (
      <div className="card-block">
        <div className="row">

          <div className="col-sm-12">
            <div className="form-group">
              <label>Username</label>
              <input 
                type="text" 
                className="form-control" 
                disabled={true}
                value={username}
              />
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label>First Name</label>
              <input 
                type="text" 
                className="form-control" 
                value={firstname}
                onChange={ (e)=> this.setState({firstname: e.target.value}) }
              />
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label>Last Name</label>
              <input 
                type="text" 
                className="form-control" 
                value={lastname}
                onChange={ (e)=> this.setState({lastname: e.target.value}) }
              />
            </div>
          </div>

          <div className="col-sm-12">
            <div className="float-right">
              <button className="btn btn-danger" onClick={()=>this.props.history.goBack()}>Close</button>
              &nbsp;
              <ButtonValidation is_process={is_process} onClick={this.onUpdateProfile}>
                Update Profile
              </ButtonValidation>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderResetPassword() {
    const {oldpassword, newpassword, is_process} = this.state

    return (
      <div className="card-block">
        <div className="row">

          <div className="col-sm-12">
            <div className="form-group">
              <label>Old Password</label>
              <input 
                type="Password" 
                className="form-control" 
                value={oldpassword}
                onChange={ (e)=> this.setState({oldpassword: e.target.value}) }
              />
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label>New Password</label>
              <input 
                type="Password" 
                className="form-control" 
                value={newpassword}
                onChange={ (e)=> this.setState({newpassword: e.target.value}) }
              />
            </div>
          </div>

          <div className="col-sm-12">
            <div className="float-right">
              <button type="reset" className="btn btn-danger" onClick={()=>this.props.history.goBack()}>Close</button>
              &nbsp;
              <ButtonValidation is_process={is_process} onClick={this.onUpdatePassword}>
                Update Password
              </ButtonValidation>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {reset} = this.state

    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <div className="card">
              
              <div className="card-header">
                <i className="fa fa-align-justify"></i> Superuser Settings
                <div className="float-right">
                  <button className="btn btn-link btn-sm" onClick={this.resetPassword}>
                    {reset ? "Back to profile" : "Reset Password"}
                  </button>
                </div>
              </div>
              {this.state.reset ? this.renderResetPassword() : this.renderProfile()}              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    UserReducer: state.UserReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    RunRedux: (data) => {
      dispatch(data);
    },
  };
};

// export default AssetScreen;
export default connect(mapStateToProps, mapDispatchToProps)(Settings);


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/superuser/user/settings.js